import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class SitesLeanTableCtrl implements IController {
  sites: any;
  sortedSites: any[];
  dynamicSitesList: any[]

  public query: string;
  public placeholder: string;

  constructor() {
  }

  $onInit() {
    this.placeholder = "Search Site"
    this.sortedSites = this.sites && this.sites.length ? (angular.copy(this.sites)).sort(this.compare) : [];
    this.dynamicSitesList = this.sortedSites;
  }

  compare(a, b) {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return -1;
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1;
    }
    return 0;
  }

  clear() {
    this.query = "";
    this.dynamicSitesList = this.sortedSites;
  }

  changeQuery() {
    this.dynamicSitesList = _.filter(this.sortedSites, (s) => {
      return s.name.toLowerCase().includes(this.query.toLowerCase());
    })

  }
}

angular
  .module('bringoz.admin.organizations')
  .component('sitesLeanTable', {
    bindings: {
      sites: '<'
    },
    template: require('./sites-lean-table.html').default,
    controller: SitesLeanTableCtrl
  });
